import { Outlet } from 'react-router-dom';
import MobileTabBar from './MobileTabBar';

export default function MobileShell() {
  return (
    <div className="flex flex-col h-screen overflow-hidden" style={{ backgroundColor: 'var(--bg-base)' }}>
      <main className="flex-1 min-h-0 overflow-y-auto">
        <Outlet />
      </main>
      <MobileTabBar />
    </div>
  );
}
